module.exports = "/packs/002-57c3ec74beb023e1cc04b76c75c6034e.jpg";